module.exports = __webpack_public_path__ + "img/Vector27.424cc1d8.svg";